var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "layoutPreviewModal",
      staticClass: "layout-preview-modal",
      attrs: { "ok-title": "Import", "cancel-title": "Close", size: "lg" },
      scopedSlots: _vm._u([
        {
          key: "modal-title",
          fn: function () {
            return [
              _vm._v(
                "\n    Layout " +
                  _vm._s(_vm.layout ? `: ${_vm.layout.name}` : "") +
                  "\n  "
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v("\n      Cancel\n    ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "d-flex align-items-center",
                  staticStyle: { gap: "8px" },
                  attrs: {
                    variant: "primary",
                    disabled: !_vm.isAddingAvailable,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.addLayers()
                    },
                  },
                },
                [
                  _vm.isAdding
                    ? _c("span", {
                        staticClass: "spinner-border spinner-border-sm",
                        attrs: { role: "status", "aria-hidden": "true" },
                      })
                    : _vm._e(),
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.isAdding ? "Adding..." : "Add") +
                      "\n    "
                  ),
                ]
              ),
            ]
          },
        },
      ]),
    },
    [
      _vm._v(" "),
      _vm.layout
        ? _c("div", { staticClass: "layout-preview-modal__container" }, [
            _c("div", { staticClass: "row w-100 h-100" }, [
              _c("div", { staticClass: "col-6" }, [
                _c("img", {
                  attrs: {
                    src: `/share?file=${_vm.layout.thumbnail}`,
                    alt: "layout-thumbnail",
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex flex-column col-6",
                  staticStyle: { gap: "8px" },
                },
                [
                  _c("div", [_c("span", [_vm._v("Templates")])]),
                  _vm._v(" "),
                  _vm._l(_vm.layout.instances, function (template) {
                    return _c("PreviewTemplate", {
                      key: template.instance_id,
                      attrs: {
                        template: template,
                        checked: _vm.selectedTemplates.some(
                          (instanceId) => instanceId === template.instance_id
                        ),
                        "selected-layers": _vm.selectedLayers,
                      },
                      on: {
                        "template-select": _vm.selectTemplate,
                        "layer-select": _vm.selectLayer,
                      },
                    })
                  }),
                ],
                2
              ),
            ]),
          ])
        : _c("span", {
            staticClass: "spinner-border spinner-border-sm",
            attrs: { role: "status", "aria-hidden": "true" },
          }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }